import { createSelector } from 'reselect';
import { TApplicationState, TEventStandingsState } from '../libs/store';

const eventStandingsState = (state: TApplicationState) => state?.eventStandings;

export const eventStandingsListStateSelector = createSelector(
  eventStandingsState,
  (state: TEventStandingsState) => state.eventStandings
);

export const eventStandingsFiltersStateSelector = createSelector(
  eventStandingsState,
  (state: TEventStandingsState) => state.eventStandingsFilters
);

export const eventAnalyticsFiltersStateSelector = createSelector(
  eventStandingsState,
  (state: TEventStandingsState) => state.eventAnalyticsFilters
);

export const requestPendingSelector = createSelector(
  eventStandingsState,
  (state: TEventStandingsState) => state.requestPending
);
